import React, { useEffect, useState } from "react";
import { Col, Container, Row } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { paginationStartFrom, signUpType } from "../data/constants";
import { useAuth } from "../Context/AuthProvider";

let page = paginationStartFrom;
function LogoutModal({ show, setShow, data, title, onYesClick }) {
    const { logout } = useAuth()
    const handleClose = () => setShow(false);

    return (
        <>
            <Modal show={show} onHide={handleClose} aria-labelledby="contained-modal-title-vcenter" centered>
                <Modal.Header className="border-0 " closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">{title}</Modal.Title>
                </Modal.Header>

                <Modal.Body className="modalBody border-0">
                    <h6 className="body_text p-3">
                        Are you sure, you want to {data}?
                    </h6>
                </Modal.Body>

                <Modal.Footer className="border-0 ">
                    <div className="d-flex justify-content-between ">
                        <div >
                            <Button className="reset_button" onClick={handleClose}>
                                No
                            </Button>
                        </div>
                        <div>
                            <Button className='submit_button mx-2' onClick={onYesClick}>
                                Yes
                            </Button>
                        </div>
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default LogoutModal;